import React from 'react'
import { cn } from '@/lib/utils'

// Static maps for Tailwind JIT compatibility
const colWidthMap: Record<number, string> = {
  1: 'w-1/12', 2: 'w-2/12', 3: 'w-3/12', 4: 'w-4/12',
  5: 'w-5/12', 6: 'w-6/12', 7: 'w-7/12', 8: 'w-8/12',
  9: 'w-9/12', 10: 'w-10/12', 11: 'w-11/12', 12: 'w-full',
}

const smColMap: Record<number, string> = {
  1: 'sm:w-1/12', 2: 'sm:w-2/12', 3: 'sm:w-3/12', 4: 'sm:w-4/12',
  5: 'sm:w-5/12', 6: 'sm:w-6/12', 7: 'sm:w-7/12', 8: 'sm:w-8/12',
  9: 'sm:w-9/12', 10: 'sm:w-10/12', 11: 'sm:w-11/12', 12: 'sm:w-full',
}

const mdColMap: Record<number, string> = {
  1: 'md:w-1/12', 2: 'md:w-2/12', 3: 'md:w-3/12', 4: 'md:w-4/12',
  5: 'md:w-5/12', 6: 'md:w-6/12', 7: 'md:w-7/12', 8: 'md:w-8/12',
  9: 'md:w-9/12', 10: 'md:w-10/12', 11: 'md:w-11/12', 12: 'md:w-full',
}

const lgColMap: Record<number, string> = {
  1: 'lg:w-1/12', 2: 'lg:w-2/12', 3: 'lg:w-3/12', 4: 'lg:w-4/12',
  5: 'lg:w-5/12', 6: 'lg:w-6/12', 7: 'lg:w-7/12', 8: 'lg:w-8/12',
  9: 'lg:w-9/12', 10: 'lg:w-10/12', 11: 'lg:w-11/12', 12: 'lg:w-full',
}

const xlColMap: Record<number, string> = {
  1: 'xl:w-1/12', 2: 'xl:w-2/12', 3: 'xl:w-3/12', 4: 'xl:w-4/12',
  5: 'xl:w-5/12', 6: 'xl:w-6/12', 7: 'xl:w-7/12', 8: 'xl:w-8/12',
  9: 'xl:w-9/12', 10: 'xl:w-10/12', 11: 'xl:w-11/12', 12: 'xl:w-full',
}

interface ContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  fluid?: boolean
}

export const Container: React.FC<ContainerProps> = ({ fluid, className, ...props }) => (
  <div className={cn(fluid ? 'w-full px-4' : 'max-w-7xl mx-auto px-4', className)} {...props} />
)

interface RowProps extends React.HTMLAttributes<HTMLDivElement> {
  noGutters?: boolean
}

export const Row: React.FC<RowProps> = ({ noGutters, className, ...props }) => (
  <div
    className={cn('flex flex-wrap', noGutters ? '' : '-mx-3', className)}
    {...props}
  />
)

interface ColProps extends React.HTMLAttributes<HTMLDivElement> {
  xs?: number | string | boolean
  sm?: number | string
  md?: number | string
  lg?: number | string
  xl?: number | string
}

export const Col: React.FC<ColProps> = ({ xs, sm, md, lg, xl, className, ...props }) => {
  const classes = cn(
    'px-3',
    // Default: full width if no breakpoint specified, auto if true
    xs === true ? 'flex-1' : typeof xs === 'number' ? colWidthMap[xs] : !sm && !md && !lg && !xl ? 'w-full' : undefined,
    typeof sm === 'number' ? smColMap[sm] : undefined,
    typeof md === 'number' ? mdColMap[md] : undefined,
    typeof lg === 'number' ? lgColMap[lg] : undefined,
    typeof xl === 'number' ? xlColMap[xl] : undefined,
    className,
  )

  return <div className={classes} {...props} />
}
